export const selectComicHistory = (state) => state.history.comic

export const selectNovelHistory = (state) => state.history.novel
